"use strict";
const config = require('../../../../../config/locales_json/packs/private/users/my_postulations.json');
const language = $('body').data("language");
// Class definition

var MyPostulationsDatatable = function () {
  // Define shared variables
  var table = document.getElementById('kt_datatable_my_postulations');
  var datatable;

  // Private functions
  var initMyPostulationTable = function () {
      // Init datatable --- more info on datatables: https://datatables.net/manual/
      datatable = $(table).DataTable({
        info: true,
        order: [[1, 'desc']],
        pageLength: 10,
        lengthChange: false,
        searching: true,
        autoWidth: false, // Desactiva el ajuste automático de ancho
        responsive: true, // Opcional: hace que la tabla sea responsive
        columns: [
          { width: '40%' },
          { width: '20%' },
          { width: '20%' },
          { width: '20%' },
        ],
        language: {
          emptyTable: "No has postulado a ninguna oferta aún",
          info: "Mostrando _START_ - _END_ de _TOTAL_ de postulaciones",
          infoEmpty: "Mostrando 0 - 0 de 0 postulaciones",
          zeroRecords: "No se encontraron postulaciones coincidentes",
          infoFiltered: "(filtro aplicado a _MAX_ postulaciones)",
      }
      });
  }

  // Search Datatable --- official docs reference: https://datatables.net/reference/api/search()
  var handleSearchDatatable = () => {
      const filterSearch = document.querySelector('[data-kt-my-postulations-table-filter="search"]');
      filterSearch.addEventListener('keyup', function (e) {
          datatable.search(e.target.value).draw();
      });
  }

  return {
      // Public functions  
      init: function () {
          if (!table) {
              return;
          }

          initMyPostulationTable();
          handleSearchDatatable();
          // Remueve el input de busqueda por defecto
          $(".dt-search").remove();
      }
  }
}();

jQuery(document).ready(function() {
  if($("#kt_datatable_my_postulations").length > 0){
    MyPostulationsDatatable.init();
  }

  /*************
     * ELIMINAR POSTULACINOES
     *
     * - Logica de activacion de modal,
     * - Asignacion de informacion a hidden field del modal
     * - Validacion y ejecución del formulario
     */
    // Al hacer click en eliminar una postulación
    $("#kt_datatable_my_postulations").on("click", ".delete-button", function(e){
      $('#delete_postulation_modal').modal('toggle')
      // Obtiene el id de la postulación
      var postulationID = $(this).attr("data-id")
      // Asigna el id de la postulación en el campo hidden del modal
      $("#delete_postulation_modal #hidden_modal_id").val(postulationID)
      // Se asigna la url correspondiente
      var url = '/postulation/unpostuled';
      $("#form_modal_delete_postulation").attr("action", url)
  })

  // Al cerrar el modal limpia la url y el hidden
  $("#delete_postulation_modal .close").on("click", function(e){
      cleanPostulationModalFields()
  })

  // Al hacer click en confirmar eliminacion de universidad
  $("#delete_postulation_modal #cancel_modal_delete_postulation_form").on("click", function(e){
      cleanPostulationModalFields()
  })

  // Al hacer click en enviar universidad
  $("#delete_postulation_modal #send_modal_delete_postulation_form").on("click", function(e){
      // Valida que el campo hidden tenga información
      var postulationID = $("#delete_postulation_modal #hidden_modal_id").val()
      // Si tiene informacion ejecuta el formulario
      if(postulationID.length > 0) {
          // Se desabilitan las acciones
          // Cambia el texto del boton a Eliminando
          const disabledText = getTranslationValue(config, [language, "on_click_send_modal_delete", "disabled_text"],"Eliminando...")
          $(this).addClass("disabled").text(disabledText)

          $("#delete_postulation_modal #cancel_modal_delete_postulation_form").addClass("disabled")
          $("#delete_postulation_modal #close_delete_postulation_modal").addClass("disabled")
          $("#form_modal_delete_postulation").submit()
      } else {
          // Si no se puede eliminar
          const errorText = getTranslationValue(config, [language, "on_click_send_modal_delete", "error_text"],"Hubo un problema y no se pudo eliminar la postulación. Por favor intente más tarde.")
          $(".modal-body").find(".error-modal").remove()
          $(".modal-body").prepend('<div class="error-modal"><i class="fas fa-times-circle"></i><p>'+errorText+'</p></div>')
      }
  })

  // Limpia el campo hidden y la url del form
  function cleanPostulationModalFields(){
      // Limpia si hay errores
      $(".modal-body").find(".error-modal").remove()
      // Limpia el campo hidden
      $("#delete_postulation_modal #hidden_modal_id").val(null)
      // Se limpia la url correspondiente
      var url = '';
      $("#form_modal_delete_postulation").attr("action", url)
  }
  /*************
   * FIN ELIMINAR UNIVERSIDAD
   */
});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;

	let currentTranslation;
	let firstIteration = true;

	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {

      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}
